import React, { useState } from 'react';
import './styles.css';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputBase from '@material-ui/core/InputBase';
import FormLabel from '@material-ui/core/FormLabel';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import useTranslation from '../../hooks/use-translation';
import moment from 'moment';
import { raiseGAEventForVaccination } from '../../utils/network'
import config from '../../config.json'

const useStyles = makeStyles((theme) => ({
  formControl: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    maxWidth: 475,
    width: '100%',
  },
  iconStyle: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    right: '10px',
    display: 'inline-block',
    color: '#FFFFFF',
    width: '20px',
    height: '20px',
    pointerEvents: 'none'
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  formLabel: {
    maxWidth: 330,
    fontSize: 16,
    width: 330,
    fontFamily: 'jioType-Medium',
    padding: '16px 22px',
    color: '#333333 !important',
    border: '1px solid #E5E5E5',
    borderRadius: '5px 0 0 5px',
    margin: '0'
  },
  menuItem: {
    backgroundColor: '#3CB5EA',
    padding: '10px 16px',
    color: '#FFFFFF',
    fontSize: '14px',
    fontFamily: 'jioType-Medium'
  },
  selected: {
    '&.Mui-selected': {
      backgroundColor: '#77CCF1 !important'
    }
  },
  root: {
    "&$selected, &$selected:focus, &$selected:hover": {
      backgroundColor: "#77CCF1"
    },
    "&.MuiListItem-root.Mui-focusVisible": {
      backgroundColor: "#77CCF1 !important"
    },
    "&.MuiListItem-button:hover": {
      backgroundColor: "#77CCF1 !important"
    }
  },
  select: {
    marginBottom: 0
  },
  list: {
    "&.MuiList-padding": {
      padding: "0 !important"
    }
  }
}));

const BootstrapInput = withStyles((theme) => ({
  input: {
    marginBottom: '0',
    borderRadius: '0 5px 5px 0',
    position: 'relative',
    backgroundColor: '#3CB5EA',
    borderBottom: '1px solid #FFFFFF',
    color: '#FFFFFF',
    fontSize: 14,
    lineHeight: '18px',
    height: '100%',
    width: 112,
    display: 'flex',
    alignItems: 'center',
    padding: '0 0 0 16px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: 'jioType-Medium',
    '&:focus': {
      backgroundColor: '#3CB5EA',
      borderRadius: '0 5px 5px 0',
      outline: '1px solid black',
    }
  },
}))(InputBase);

const dateFormat = "DD-MM-YYYY";

const VaccinationDoseInfo = ({ vaccines = [],
  onSubmit = () => { }, doseNo = '', resetButtons, reloadData }) => {
  const classes = useStyles();
  const [vaccine, setVaccine] = useState({ value: '', error: '' });
  const [date, setDate] = useState({ value: '', error: '' });
  const [apiError, setApiError] = useState(false);
  const { t } = useTranslation();

  const validateInputs = () => {
    let areValid = true;
    if (vaccine.value.length === 0) {
      setVaccine(s => ({ ...s, error: t("SELECT_VACCINE_NAME_ERROR") }));
      areValid = false;
    } if (date.value === "" || new Date(date.value).getTime() > new Date().getTime() || !(moment(moment(date.value).format(dateFormat), dateFormat, true).isValid())) {
      var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

      if (isSafari)
        setDate({
          ...date,
          error: "Please enter a valid date in YYYY-MM-DD"
        })

      else
        setDate({
          ...date,
          error: "Please enter a valid date"
        })

      areValid = false;
    }
    return areValid;
  }

  const handleSubmit = async () => {
    if (!validateInputs()) return;
    // raiseGAEventForVaccination({ new_Action: config.gaEnterInfoSubmit, new_Label: `Dose-${doseNo}`, new_Category: config.gaMyVaccination })
    const [success, message] = await onSubmit([{
      name: vaccine.value,
      date_of_vaccination: date.value,
      dose: doseNo
    }]);
    if (success) {
      setTimeout(() => {
        reloadData();
        resetButtons();
      }, 500)
    } else {
      setDate({...date, error:message})
      setApiError(true);
    }
  }

  return (
    <div className='mt30'>
      <FormControl className={classes.formControl}>
        <FormLabel className={`${classes.formLabel} ${vaccine.error.length > 0 ? 'redError' : ''}`}>{`${t("NAME_OF_VACCINE_DOSE")}${doseNo}`}</FormLabel>
        <Select
          IconComponent={() => <KeyboardArrowDownIcon className={classes.iconStyle} />}
          displayEmpty
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left"
            },
            style: {
              padding: 0
            },
            getContentAnchorEl: null,
            transitionDuration: 0,
            classes: { list: classes.list }
          }}
          renderValue={(value) => {
            if (!value) return t("SELECT");
            return value;
          }}
          className={classes.select}
          value={vaccine.value}
          onChange={(e) => setVaccine({ value: e.target.value, error: '' })}
          input={<BootstrapInput />}
          id="vaccine_select"
        >
          {vaccines.map((item, index) => (
            <MenuItem key={index} classes={{ selected: classes.selected, root: classes.root }} className={classes.menuItem} value={item.name}>{item.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <div className={`errorMessage ${vaccine.error.length > 0 ? '' : 'mb20'}`}>{vaccine.error}</div>
      <FormControl className={classes.formControl}>
        <FormLabel className={`${classes.formLabel} ${date.error.length > 0 && !apiError ? 'redError' : ''}`}>{`${t("DATE_OF_VACCINE_DOSE")}${doseNo}`}</FormLabel>
        <input max={moment().utcOffset("+05:30").format("YYYY-MM-DD")} className={`dateInput ${date.error.length > 0 && !apiError ? 'redError' : ''}`} placeholder='yyyy-mm-dd' value={date.value} onChange={(e) => {setDate({ value: e.target.value, error: '' }); setApiError(false)}} type='date' />
      </FormControl>
      <div className={`errorMessage ${date.error.length > 0 ? '' : 'mb20'}`}>{date.error}</div>
      <button className='submitBtn' type='button' onClick={handleSubmit}>{t('SUBMIT')}</button>
    </div>
  );
};

export default VaccinationDoseInfo;